'use strict';

/* globals COMMIT */

import title from 'helpers/title';
import MainRouter from './routers/Main.js';
import AppView from './views/App';
import Log from 'lib/log';
import User from 'newModels/user.js';
import Banks from 'newCollections/banks.js';
import axios from 'axios';
const swal = require('sweetalert2');
const log = Log();

const Decimal = require('decimal.js');

require('moment-timezone');
require('moment').tz.guess();
require('moment').locale('my', {
    weekdaysShort: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    week: {
        dow: 1,
        doy: 4
    }
});

require('metismenu');
require('jquery-slimscroll');
require('slick-carousel');
require('bootstrap-datepicker');
require('icheck');
require('typeahead.js');
require('jquery-steps/build/jquery.steps.js');
require('footable/dist/footable.all.min.js');
require('jquery.inputmask/dist/jquery.inputmask.bundle.js');
require('chosen-js');
require('pwstrength-bootstrap/dist/pwstrength-bootstrap.js');

require('lib/jquery.blockUI.js');
require('lib/inspinia.js');

require.context('../images', false, /^\.\//);
require.context('../files', false, /^\.\//);

log.info('App starting...');

function checkAppUpdated(force) {
    const timestamp = new Date().getTime().toString();
    axios.get(`${window.location.origin}/build-info.json?cb=${timestamp}`)
        .then(res => {
            try {
                const commit = res.data.commit;
                if ((commit && COMMIT && commit !== COMMIT) || force) {
                    swal({
                        title: 'The app has been updated.',
                        text: 'You should reload it now to get the latest version'
                    });
                }
            } catch (e) {
                log.error('Error parsing app version');
                log.error(e);
            }
        })
        .catch(e => {
            log.error('Error fetching app version');
            log.error(e);
        });
}

setTimeout(checkAppUpdated, 15 * 1000);
setInterval(checkAppUpdated, 10 * 60 * 1000); // every 10 minutes

window.checkAppUpdated = checkAppUpdated;

$(function() {
    title({base: 'PayrollPanda:'});

    window.app = {
        version:      VERSION,
        view:         new AppView(),
        contentView:  null,
        mainRouter:   null,
        events:       _.extend({}, Backbone.Events),
        user:         new User(),
        banks:        new Banks(),
        company:      null,
        subscription: null,
        holidays:     null,
        payrollItems: null,
        leaveTypes:   null,
        reload:       function() {
            window.location.href = '/' + window.location.search;
        },
        refresh: function() {
            window.location.reload();
        }
    };

    // formatiting numbers without rounding
    Number.prototype.formatWithoutRounding = function(dp = 2) {
        return new Decimal(this)
            .toDP(dp, Decimal.ROUND_DOWN)
            .toFixed(dp);
    };
    // The db contains strings in several places where it should be a number
    String.prototype.formatWithoutRounding = function(dp = 2) {
        const number = Number(this);
        return isNaN(number) ? this.format() : number.formatWithoutRounding(dp);
    };

    $(window).bind('beforeunload', function() {
        var status = {unsaved: false};
        app.events.trigger('navigate', status);

        if (status.unsaved === true) {
            return status.msg || 'There are unsaved changes. Leaving this ' +
                'page will result in the changes being discarded.';
        }
    });

    // Load user if available
    const accessToken = app.user.getAccessToken();
    let onUserReady;
    if (accessToken) {
        log.info(`Fetching user ${accessToken.userId}`);
        app.user.set({id: accessToken.userId});
        onUserReady = app.user.fetch()
            .then(app.banks.fetch({filter: {limit: 9999}}));
    } else {
        onUserReady = Promise.resolve(true);
    }

    // load main router
    onUserReady
        .then(() => {
            app.mainRouter = new MainRouter();
            return true;
        })
        .catch(err => {
            log.error(err);

            if (err.response &&
                err.response.error &&
                err.response.error.statusCode === 401
            ) {
                log.info('Removing invalid access token');
                app.user.removeAccessToken();
                window.location.href = '/';
            }
        });
});



// WEBPACK FOOTER //
// ./app/payrollpanda.js